import EventEmitter from './EventEmitter';
class Pending extends EventEmitter {
    _target;
    _value;
    constructor(_target, _value) {
        super();
        this._target = _target;
        this._value = _value;
        this._init();
    }
    _init() {
        this._value.on('change', this._onValueChanged);
    }
    _onValueChanged = (value) => {
        const isReady = this.isReady(value);
        if (!isReady)
            return;
        this.emit('ready');
    };
    isReady(value) {
        return value.getValue() === this._target.getValue();
    }
}
export default Pending;
